document.querySelectorAll('form.cart').forEach(function(productForm) {
    class FabricMainSidebar {
        constructor(productForm) {
            //Переменные
            this.sidebar = productForm.querySelector('.fabric-main-sidebar');
            this.sidebarDetails = productForm.querySelector('.fabric-main-details-sidebar');
            this.sidebarQr = productForm.querySelector('.fabric-main-qr-sidebar');
            this.modalQr = productForm.querySelector('.fabric-main-qr-modal');
            this.qrPromise = undefined;
            this.qrScanner = undefined;
            this.isNeedUpdateFilters = true;
            this.isNeedUpdateContent = true;
            this.isNeedUpdateDetailsContent = true;
            this.isNeedUpdateQrContent = true;
            this.product = productForm.classList.contains('variations_form') ? current_variation : JSON.parse(productForm.dataset.product);
            this.zarboFabrics = [];
            this.filters = {};
            this.colors = new Map();
            this.categories = new Map();
            this.textures = new Map();
            this.properties = new Map();
            this.fabrics = [];

            //Действия
            //Получить zarbo ткани
            if (
                typeof this.product['zarbo'] === 'object' && Object.keys(this.product['zarbo']).length
                && typeof this.product['zarbo']['shaders'] === 'object' && Object.keys(this.product['zarbo']['shaders']).length
                && 'Ткань' in this.product['zarbo']['shaders']
            ) {
                this.zarboFabrics = this.product['zarbo']['shaders']['Ткань'];
            }
            //Распарсить объект тканей
            let fabricObject = productForm.dataset.fabric_object;
            if (!fabricObject) return;
            fabricObject = JSON.parse(productForm.dataset.fabric_object);
            //Сформировать кеш цветов
            fabricObject['colors'].forEach(color => this.colors.set(color['id'], color));
            //Сформировать кеш категорий
            fabricObject['categories'].forEach(category => {
                category['name'] = /^\d+$/.test(category['name']) ? Number(category['name']) : category['name'];

                this.categories.set(category['id'], category);
            });
            //Сформировать кеш фактур
            fabricObject['textures'].forEach(texture => this.textures.set(texture['id'], texture));
            this.textures.set(1, {
                'id': 1,
                'name': 'По каталогу'
            });
            //Сформировать кеш свойств
            fabricObject['properties'].forEach(property => this.properties.set(property['id'], property));
            //Установить переменную тканей
            this.fabrics = fabricObject['fabrics'];
            [...this.categories].forEach((category, index) => this.fabrics.push({
                'id': index + 1,
                'slug': '',
                'sku': '',
                'title': 'Ткань ' + category['name'] + ' категории',
                'description': 'Ткань по каталогу',
                'type': 'catalog',
                'preview_url': '/wp-content/themes/savoy-child/assets/img/fabric-catalog.png',
                'gallery_urls': [],
                'color_id': '',
                'category_id': category['id'],
                'texture_id': 1,
                'property_ids': [],
                'collection': '',
                'martindale': '',
                'density': '',
                'composition': '',
                'country': '',
                'ncs': '',
                'ral': '',
                'popularity': ''
            }));
            //Установить текущую ткань
            const fabricInput = this.sidebar.querySelector('input[name="po[fabric]"]');
            this.setFabric(Number(fabricInput.value));

            //События
            //При смене вариации
            jQuery(productForm).on('show_variation', (event, variation) => {
                this.filters = {};
                this.isNeedUpdateFilters = true;
                this.isNeedUpdateContent = true;
                this.product = variation;
                //Получить zarbo ткани
                if (
                    typeof this.product['zarbo'] === 'object' && Object.keys(this.product['zarbo']).length
                    && typeof this.product['zarbo']['shaders'] === 'object' && Object.keys(this.product['zarbo']['shaders']).length
                    && typeof this.product['zarbo']['shaders'] === 'object' && Object.keys(this.product['zarbo']['shaders']).length
                    && 'Ткань' in this.product['zarbo']['shaders']
                ) {
                    this.zarboFabrics = this.product['zarbo']['shaders']['Ткань'];
                }
            });

            //Открыть сайдбар
            jQuery(productForm).on('click', '.fabric-main-trigger', () => {
                //Открыть оверлей
                jQuery(document.body).trigger('overlay_open');

                this.openSidebar();
            });
            //Закрыть сайдбар при закрытии оверлея
            jQuery(document.body).on('overlay_closed', () => {
                //Проверяем открыт ли сайдбар, если нет ничего не делаем
                if (!this.sidebar.classList.contains('open')) return;
                //Закрыть сайдбар
                this.closeSidebar();
                //Проверяем активна ли текущая ткань, если да - ничего не делаем
                if (current_fabric.id === Number(this.sidebar.querySelector('.item.active').dataset.id)) return;
                //Сбросить статус обновления контента
                this.isNeedUpdateContent = true;
                //Выбрать новую ткань
                this.setFabric(this.sidebar.querySelector('.item.active').dataset.id);
            });
            //Открыть/закрыть фильтры по клику на кнопке
            jQuery(this.sidebar).on('click', '.filter-trigger', (event) => {
                event.currentTarget.classList.contains('active') ? this.closeFilters() : this.openFilters();
            });
            //Закрыть фильтры по клику вне фильтров и вне кнопки
            jQuery(document.body).on('click', (event) => {
                if (!event.target.closest('.filter-button') && !event.target.closest('.filter-wrapper')) this.closeFilters();
            });
            //Применить фильтр
            jQuery(this.sidebar).on('keydown', 'input.filter', (event) => {
                //Запретить ввод букв в поле с типом число
                if ((event.currentTarget.type === 'number' || event.currentTarget.inputmode === 'numeric') && isLetterEntered(event)) {
                    event.preventDefault();
                }
                //Запретить отправку формы и вызвать событие изменение
                if (event.key === 'Enter') {
                    event.preventDefault();
                    event.currentTarget.dispatchEvent(new CustomEvent('change', {'bubbles': true}));
                }
            });
            jQuery(this.sidebar).on('change', 'input.filter', event => {
                const value = event.currentTarget.type === 'checkbox' ? event.target.checked : event.target.value;
                this.setFilter(event.currentTarget.dataset.group, event.currentTarget.dataset.id, value);
                this.updateFilters();
                this.updateContent();
            });
            //Сбросить фильтры
            jQuery(this.sidebar).on('click', '.reset-button', () => {
                this.filters = {};

                this.updateFilters();
                this.updateContent();
            });
            //Предвыбрать ткань
            jQuery(this.sidebar).on('click', '.item', event => {
                //Ничего не делаем, если клик по уже выбранной ткани
                if (event.currentTarget.classList.contains('active')) return;
                //Предвыбрать новую ткань
                this.preSelectFabric(event.currentTarget.dataset.id);
            });
            //Установить ткань
            jQuery(this.sidebar).on('click', '.fabric-sidebar-footer .button', event => {
                //Ничего не делаем, если кнопка не активна
                if (event.currentTarget.classList.contains('disabled')) return;
                //Сбросить статус обновления контента
                this.isNeedUpdateContent = true;
                //Выбрать новую ткань
                this.setFabric(this.sidebar.querySelector('.item.active').dataset.id);
                //Закрываем сайдбар
                jQuery(document.body).trigger('overlay_close');
            });
            jQuery(productForm).on('click', '.fabric-favorite .item', event => this.setFabric(Number(event.currentTarget.dataset.id)));
            //Открыть сайдбар с детальным просмотром ткани
            jQuery(this.sidebar).on('click', '.item .info', event => {
                event.stopPropagation();
                //Открыть оверлей
                jQuery(document.body).trigger('overlay_open');

                if (Number(event.currentTarget.closest('.item').dataset.id) !== Number(this.sidebarDetails.dataset.id)) {
                    this.isNeedUpdateDetailsContent = true;

                    //Устанавливаем id ткани для сайдбара
                    this.sidebarDetails.dataset.id = event.currentTarget.closest('.item').dataset.id;
                }

                this.openDetailsSidebar();
            });
            //Закрыть сайдбар детального просмотра ткани при закрытии оверлея
            jQuery(document.body).on('overlay_closed', () => this.closeDetailsSidebar());
            //Esc: сначала закрывается детальный просмотр ткани, иначе окна тканей — как крестиком.
            //Открытое поверх окно Popup Maker закрывается само
            document.addEventListener('keydown', event => {
                if (event.key !== 'Escape' || document.querySelector('.pum.pum-active')) return;

                if (this.sidebarDetails.classList.contains('open')) {
                    this.closeDetailsSidebar();
                } else if (
                    this.sidebar.classList.contains('open')
                    || this.sidebarQr.classList.contains('open')
                    || this.modalQr.classList.contains('open')
                ) {
                    this.closeFilters();
                    jQuery(document.body).trigger('overlay_close');
                }
            });
            //Установить избранные ткани
            jQuery(this.sidebarDetails).on('click', '.favorite-button', () => {
                const fabric = this.fabrics.find(fabric => fabric['id'] === Number(this.sidebarDetails.dataset.id));
                if (fabric) {
                    let fabrics = current_fabrics_favorites;

                    if (current_fabrics_favorites.some(_fabric => _fabric['id'] === fabric['id'])) {
                        fabrics = fabrics.filter(_fabric => _fabric['id'] !== fabric['id']);
                    } else {
                        if (fabrics.length >= 6) fabrics.splice(0, fabrics.length - 5);
                        fabrics.push(fabric);
                    }

                    setFabricsFavorites(fabrics);
                    this.updateDetailsContent();
                }
            });
            //Открыть сайдбар с детальным просмотром ткани у образцов ткани
            jQuery(this.sidebarDetails).on('click', '.sample-button', () => {
                this.closeSidebar();

                this.closeDetailsSidebar();

                jQuery(productForm).trigger('fabric_sample_details_sidebar_open', Number(this.sidebarDetails.dataset.id));
            });
            //Установить ткань из сайдбара детального просмотра ткани
            jQuery(this.sidebarDetails).on('click', '.fabric-details-sidebar-footer .button', event => {
                //Ничего не делаем, если кнопка не активна
                if (event.currentTarget.classList.contains('disabled')) return;
                //Выбрать новую ткань
                event.currentTarget.classList.add('disabled');
                this.setFabric(this.sidebarDetails.dataset.id);
                //Обновляем контент основного сайдбара
                this.updateContent();
                //Закрываем сайдбар
                this.closeDetailsSidebar();
            });
            //Открыть модальное окно/сайдбар QR
            jQuery(this.sidebar).on('click', '.qr-trigger', async () => {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
                    await this.loadQRLib();

                    this.openQrSidebar();
                } else {
                    this.closeSidebar();

                    this.openModalQr();
                }
            });
            //Закрыть модальное окно QR
            jQuery(document.body).on('overlay_closed', () => this.closeModalQr());
            //Закрыть сайдбар сканера QR
            jQuery(document.body).on('overlay_closed', () => {
                if (
                    this.qrScanner
                    && (
                        this.qrScanner.getState() === Html5QrcodeScannerState.SCANNING
                        || this.qrScanner.getState() === Html5QrcodeScannerState.PAUSED
                    )
                ) {
                    this.qrScanner.stop();
                }

                this.closeQrSidebar();
            });
        }

        openSidebar() {
            this.sidebar.classList.add('open');

            //Обновить содержимое сайдбара при открытии
            if (this.isNeedUpdateFilters) this.updateFilters();
            if (this.isNeedUpdateContent) this.updateContent();

            jQuery(document.body).trigger('fabric_main_sidebar_opened');
        }

        closeSidebar() {
            if (this.sidebar.classList.contains('open')) {
                this.sidebar.classList.remove('open');

                jQuery(document.body).trigger('fabric_main_sidebar_closed');
            }
        }

        openFilters() {
            this.sidebar.querySelector('.filter-button').classList.add('active');
            this.sidebar.querySelector('.filters').classList.add('open');
        }

        closeFilters() {
            this.sidebar.querySelector('.filter-button').classList.remove('active');
            this.sidebar.querySelector('.filters').classList.remove('open');
        }

        updateFilters() {
            //Меняем статус обновления фильтров
            this.isNeedUpdateFilters = false;

            //Подготавливаем данные для фильтров
            //Поиск
            if (!('search' in this.filters)) {
                this.filters['search'] = {};
                this.filters['search']['keywords'] = '';
            }
            //Цена
            if (!('price' in this.filters)) {
                this.filters['price'] = {};
                const numericalCategories = Array.from(this.categories.values()).filter(category => typeof category['name'] === 'number');
                this.filters['price']['min'] = this.product['display_price'] + this.getCategoryPrice(numericalCategories[0]['id']);
                this.filters['price']['current-min'] = this.filters['price']['min'];
                this.filters['price']['max'] =
                    this.product['display_price'] + this.getCategoryPrice(numericalCategories[numericalCategories.length - 1]['id']);
                this.filters['price']['current-max'] = this.filters['price']['max'];
            }
            //Режим каталога
            if (!('catalog' in this.filters)) {
                this.filters['catalog'] = {};
                this.filters['catalog']['isCatalogMode'] = false;
            }
            //Категории
            if (!('category' in this.filters)) {
                this.filters['category'] = {};
                this.categories.forEach(category => {
                    this.filters['category'][category['id']] = false;
                });
            }
            //Цвет
            if (!('color' in this.filters)) {
                this.filters['color'] = {};
                this.colors.forEach(color => {
                    this.filters['color'][color['id']] = false;
                });
            }
            //Фактура
            if (!('texture' in this.filters)) {
                this.filters['texture'] = {};
                this.textures.forEach(texture => {
                    this.filters['texture'][texture['id']] = false;
                });
            }
            //Избранное
            if (!('favorite' in this.filters)) {
                this.filters['favorite'] = {};
                this.filters['favorite']['isFavorite'] = false;
            }
            //AR
            if (!('ar' in this.filters)) {
                this.filters['ar'] = {};
                this.filters['ar']['isAr'] = false;
            }
            //Свойства
            if (!('property' in this.filters)) {
                this.filters['property'] = {};
                this.properties.forEach(property => {
                    this.filters['property'][property['id']] = false;
                });
            }

            //Строка поиска
            const searchWrapper = this.sidebar.querySelector('.search-wrapper');
            searchWrapper.innerHTML = '';
            if ('search' in this.filters) {
                const searchInput = document.createElement('input');
                searchInput.classList.add('fabric-sidebar__search');
                searchInput.classList.add('filter');
                searchInput.dataset.group = 'search';
                searchInput.dataset.id = 'keywords';
                searchInput.type = 'text';
                searchInput.placeholder = 'Найти ткань';
                searchInput.value = this.filters['search']['keywords'];
                searchWrapper.appendChild(searchInput);

                if (this.filters['search']['keywords']) {
                    const resetSearch = document.createElement('div');
                    resetSearch.classList.add('fabric-sidebar__reset-search');
                    searchWrapper.appendChild(resetSearch);
                    resetSearch.addEventListener('click', () => {
                        delete this.filters['search'];

                        this.updateFilters();
                        this.updateContent();
                    });
                }
            }

            //Счётчик фильтров
            const filtersButtonCounter = this.sidebar.querySelector('.filter-count');
            const filtersCount = this.getCountFilters();
            filtersCount ? filtersButtonCounter.classList.remove('hidden') : filtersButtonCounter.classList.add('hidden');
            filtersButtonCounter.innerHTML = filtersCount;

            //Блок фильтров
            const filters = this.sidebar.querySelector('.filters');
            filters.innerHTML = '';

            const filtersPopUp = document.createElement('div');
            filtersPopUp.classList.add('fabric-sidebar-filters__pop-up');
            filters.appendChild(filtersPopUp);

            const filtersPopUpWrapper = document.createElement('div');
            filtersPopUpWrapper.classList.add('fabric-sidebar-filters__wrapper');
            filtersPopUpWrapper.classList.add('filter-wrapper');
            filtersPopUp.appendChild(filtersPopUpWrapper);

            if ('price' in this.filters) {
                const priceWrapper = document.createElement('div');
                priceWrapper.classList.add('fabric-sidebar-filters__group-wrapper');
                priceWrapper.classList.add('price');
                filtersPopUpWrapper.appendChild(priceWrapper);

                const firstPriceText = document.createElement('span');
                firstPriceText.classList.add('fabric-sidebar-filters__price-text');
                firstPriceText.innerText = 'цена от';
                priceWrapper.appendChild(firstPriceText);

                const firstPriceInput = document.createElement('input');
                firstPriceInput.classList.add('fabric-sidebar-filters__price-field');
                firstPriceInput.classList.add('filter');
                firstPriceInput.dataset.group = 'price';
                firstPriceInput.dataset.id = 'min';
                firstPriceInput.inputmode = 'numeric';
                firstPriceInput.type = 'text';
                firstPriceInput.value = new Intl.NumberFormat("ru-RU").format(this.filters['price']['current-min']);
                priceWrapper.appendChild(firstPriceInput);

                const secondPriceText = document.createElement('span');
                secondPriceText.classList.add('fabric-sidebar-filters__price-text');
                secondPriceText.innerText = '₽ – до';
                priceWrapper.appendChild(secondPriceText);

                const secondPriceInput = document.createElement('input');
                secondPriceInput.classList.add('fabric-sidebar-filters__price-field');
                secondPriceInput.classList.add('filter');
                secondPriceInput.dataset.group = 'price';
                secondPriceInput.dataset.id = 'max';
                secondPriceInput.inputmode = 'numeric';
                secondPriceInput.type = 'text';
                secondPriceInput.value = new Intl.NumberFormat("ru-RU").format(this.filters['price']['current-max']);
                priceWrapper.appendChild(secondPriceInput);

                const thirdPriceText = document.createElement('span');
                thirdPriceText.classList.add('fabric-sidebar-filters__price-text');
                thirdPriceText.innerText = '₽';
                priceWrapper.appendChild(thirdPriceText);
            }

            if ('category' in this.filters && 'catalog' in this.filters) {
                const categoryWrapper = document.createElement('div');
                categoryWrapper.classList.add('fabric-sidebar-filters__group-wrapper');
                categoryWrapper.classList.add('category');
                filtersPopUpWrapper.appendChild(categoryWrapper);

                Object.keys(this.filters['category']).forEach(categoryId => {
                    categoryId = Number(categoryId);
                    const category = this.categories.get(categoryId);

                    if (this.filters['catalog']['isCatalogMode'] || !category['isEmpty']) {
                        const categoryItem = document.createElement('label');
                        categoryItem.classList.add('fabric-sidebar-filters__item');
                        categoryWrapper.appendChild(categoryItem);

                        const categoryInput = document.createElement('input');
                        categoryInput.classList.add('filter');
                        categoryInput.classList.add('hidden');
                        categoryInput.dataset.group = 'category';
                        categoryInput.dataset.id = categoryId;
                        categoryInput.type = 'checkbox';
                        categoryInput.checked = this.filters['category'][categoryId];
                        categoryItem.appendChild(categoryInput);

                        const categoryInner = document.createElement('span');
                        categoryInner.classList.add('fabric-sidebar-filters__item-inner');
                        categoryInner.innerHTML = (category['name'] === 1 ? 'Категория ' : '') + category['name'];
                        categoryItem.appendChild(categoryInner);
                    }
                });

                const catalogCategoryItem = document.createElement('label');
                catalogCategoryItem.classList.add('fabric-sidebar-filters__item');
                categoryWrapper.appendChild(catalogCategoryItem);

                const catalogCategoryInput = document.createElement('input');
                catalogCategoryInput.classList.add('filter');
                catalogCategoryInput.classList.add('hidden');
                catalogCategoryInput.dataset.group = 'catalog';
                catalogCategoryInput.dataset.id = 'isCatalogMode';
                catalogCategoryInput.type = 'checkbox';
                catalogCategoryInput.checked = this.filters['catalog']['isCatalogMode'];
                catalogCategoryInput.value = 'По каталогу';
                catalogCategoryItem.appendChild(catalogCategoryInput);

                const catalogCategoryInner = document.createElement('span');
                catalogCategoryInner.classList.add('fabric-sidebar-filters__item-inner');
                catalogCategoryInner.innerHTML = 'По каталогу';
                catalogCategoryItem.appendChild(catalogCategoryInner);
            }

            if ('color' in this.filters) {
                const colorWrapper = document.createElement('div');
                colorWrapper.classList.add('fabric-sidebar-filters__group-wrapper');
                colorWrapper.classList.add('color');
                filtersPopUpWrapper.appendChild(colorWrapper);

                Object.keys(this.filters['color']).forEach(colorId => {
                    colorId = Number(colorId);
                    const color = this.colors.get(colorId);

                    const colorItem = document.createElement('label');
                    colorItem.classList.add('fabric-sidebar-filters__item');
                    colorWrapper.appendChild(colorItem);

                    const colorInput = document.createElement('input');
                    colorInput.classList.add('filter');
                    colorInput.classList.add('hidden');
                    colorInput.dataset.group = 'color';
                    colorInput.dataset.id = colorId;
                    colorInput.type = 'checkbox';
                    colorInput.checked = this.filters['color'][colorId];
                    colorItem.appendChild(colorInput);

                    const colorInner = document.createElement('div');
                    colorInner.classList.add('fabric-sidebar-filters__color-inner');
                    colorInner.style.backgroundColor = '#' + color['hex'];
                    colorInner.title = color['name'];
                    colorItem.appendChild(colorInner);
                });
            }

            if ('texture' in this.filters) {
                const textureWrapper = document.createElement('div');
                textureWrapper.classList.add('fabric-sidebar-filters__group-wrapper');
                textureWrapper.classList.add('texture');
                filtersPopUpWrapper.appendChild(textureWrapper);

                Object.keys(this.filters['texture']).forEach(textureId => {
                    textureId = Number(textureId);
                    const texture = this.textures.get(textureId);

                    //Если по каталогу, то не отображать
                    if (texture['name'] === 'По каталогу') return;

                    const textureItem = document.createElement('label');
                    textureItem.classList.add('fabric-sidebar-filters__item');
                    textureWrapper.appendChild(textureItem);

                    const textureInput = document.createElement('input');
                    textureInput.classList.add('filter');
                    textureInput.classList.add('hidden');
                    textureInput.dataset.group = 'texture';
                    textureInput.dataset.id = textureId;
                    textureInput.type = 'checkbox';
                    textureInput.checked = this.filters['texture'][textureId];
                    textureItem.appendChild(textureInput);

                    const textureInner = document.createElement('div');
                    textureInner.classList.add('fabric-sidebar-filters__item-inner');
                    textureInner.innerHTML = texture['name'];
                    textureItem.appendChild(textureInner);
                });
            }

            const close = document.createElement('a');
            close.classList.add('fabric-sidebar-filters__close');
            close.innerHTML = 'Показать ткани';
            filtersPopUpWrapper.appendChild(close);
            close.addEventListener('click', () => this.closeFilters());

            if (filtersCount) {
                const resetFilterButton = document.createElement('a');
                resetFilterButton.classList.add('fabric-sidebar__reset-button');
                resetFilterButton.classList.add('reset-button');
                resetFilterButton.innerHTML = 'Сбросить фильтры';
                filtersPopUpWrapper.appendChild(resetFilterButton);
            }

            //Слайдер с фильтрами
            const filtersSlider = this.sidebar.querySelector('.fabric-sidebar-slider');
            filtersSlider.innerHTML = '';

            const filtersSliderWrapper = document.createElement('div');
            filtersSliderWrapper.classList.add('fabric-sidebar-slider__wrapper');
            filtersSliderWrapper.classList.add('wrapper');
            filtersSlider.appendChild(filtersSliderWrapper);

            const qrSlide = document.createElement('div');
            qrSlide.classList.add('fabric-sidebar-slider__slide');
            qrSlide.classList.add('fabric-sidebar-filters__item');
            qrSlide.classList.add('qr-trigger');
            qrSlide.classList.add('slide');
            qrSlide.classList.add('qr');
            filtersSliderWrapper.appendChild(qrSlide);

            const qrSlideInner = document.createElement('span');
            qrSlideInner.classList.add('fabric-sidebar-filters__item-inner');
            qrSlideInner.innerHTML = 'Скан QR';
            qrSlide.appendChild(qrSlideInner);

            const favoriteSlide = document.createElement('label');
            favoriteSlide.classList.add('fabric-sidebar-slider__slide');
            favoriteSlide.classList.add('fabric-sidebar-filters__item');
            favoriteSlide.classList.add('slide');
            filtersSliderWrapper.appendChild(favoriteSlide);

            if ('favorite' in this.filters) {
                const favoriteSlideInput = document.createElement('input');
                favoriteSlideInput.classList.add('filter');
                favoriteSlideInput.classList.add('hidden');
                favoriteSlideInput.dataset.group = 'favorite';
                favoriteSlideInput.dataset.id = 'isFavorite';
                favoriteSlideInput.type = 'checkbox';
                favoriteSlideInput.checked = this.filters['favorite']['isFavorite'];
                favoriteSlide.appendChild(favoriteSlideInput);

                const favoriteSlideInner = document.createElement('span');
                favoriteSlideInner.classList.add('fabric-sidebar-filters__item-inner');
                favoriteSlideInner.innerHTML = 'Избранные';
                favoriteSlide.appendChild(favoriteSlideInner);
            }

            if ('ar' in this.filters) {
                const arSlide = document.createElement('label');
                arSlide.classList.add('fabric-sidebar-slider__slide');
                arSlide.classList.add('fabric-sidebar-filters__item');
                arSlide.classList.add('slide');
                arSlide.classList.add('ar');
                filtersSliderWrapper.appendChild(arSlide);

                const arSlideInput = document.createElement('input');
                arSlideInput.classList.add('filter');
                arSlideInput.classList.add('hidden');
                arSlideInput.dataset.group = 'ar';
                arSlideInput.dataset.id = 'isAr';
                arSlideInput.type = 'checkbox';
                arSlideInput.checked = this.filters['ar']['isAr'];
                arSlide.appendChild(arSlideInput);

                const arSlideInner = document.createElement('span');
                arSlideInner.classList.add('fabric-sidebar-filters__item-inner');
                arSlideInner.innerHTML = 'AR';
                arSlide.appendChild(arSlideInner);
            }

            if ('property' in this.filters) {
                Object.keys(this.filters['property']).forEach(propertyID => {
                    propertyID = Number(propertyID);
                    const property = this.properties.get(propertyID);

                    const slide = document.createElement('label');
                    slide.classList.add('fabric-sidebar-slider__slide');
                    slide.classList.add('fabric-sidebar-filters__item');
                    slide.classList.add('slide');
                    filtersSliderWrapper.appendChild(slide);

                    const slideInput = document.createElement('input');
                    slideInput.classList.add('filter');
                    slideInput.classList.add('hidden');
                    slideInput.dataset.group = 'property';
                    slideInput.dataset.id = propertyID;
                    slideInput.type = 'checkbox';
                    slideInput.checked = this.filters['property'][propertyID];
                    slide.appendChild(slideInput);

                    const slideInner = document.createElement('span');
                    slideInner.classList.add('fabric-sidebar-filters__item-inner');
                    slideInner.innerHTML = property['name'];
                    slide.appendChild(slideInner);
                });

                new Swiper(filtersSlider, {
                    'wrapperClass': 'wrapper',
                    'slideClass': 'slide',
                    'slidesPerView': 'auto',
                    'spaceBetween': 5
                });
            }
        }

        getCountFilters() {
            let count = 0;

            //Посчитать кол-во фильтров
            Object.keys(this.filters).forEach(filterGroup => {
                if (filterGroup === 'price') {
                    if (this.filters[filterGroup]['current-min'] !== this.filters[filterGroup]['min']) count++;
                    if (this.filters[filterGroup]['current-max'] !== this.filters[filterGroup]['max']) count++;
                } else {
                    Object.values(this.filters[filterGroup]).forEach(filter => {
                        if (filter) count++;
                    });
                }
            });

            return count;
        }

        setFilter(group, id, value) {
            //Поиск
            if (group === 'search' && id === 'keywords') this.filters['search']['keywords'] = value;

            //Цена
            else if (group === 'price') {
                value = Number(value.replace(/\s+/g, ''));

                if (id === 'min') {
                    if (this.filters['price']['min'] > value) {
                        this.filters['price']['current-min'] = this.filters['price']['min'];
                    } else if (value > this.filters['price']['current-max']) {
                        this.filters['price']['current-min'] = this.filters['price']['current-max'];
                    } else {
                        this.filters['price']['current-min'] = value;
                    }
                } else if (id === 'max') {
                    if (this.filters['price']['current-min'] > value) {
                        this.filters['price']['current-max'] = this.filters['price']['current-min'];
                    } else if (value > this.filters['price']['max']) {
                        this.filters['price']['current-max'] = value > this.filters['price']['max'];
                    } else {
                        this.filters['price']['current-max'] = value;
                    }
                }
            }

            //Каталог
            else if (group === 'catalog' && id === 'isCatalogMode') this.filters['catalog']['isCatalogMode'] = value;

            //Категории
            else if (group === 'category') this.filters['category'][id] = value;

            //Цвет
            else if (group === 'color') this.filters['color'][id] = value;

            //Фактура
            else if (group === 'texture') this.filters['texture'][id] = value;

            //Избранное
            else if (group === 'favorite' && id === 'isFavorite') this.filters['favorite']['isFavorite'] = value;

            //AR
            else if (group === 'ar' && id === 'isAr') this.filters['ar']['isAr'] = value;

            //Свойства
            else if (group === 'property') this.filters['property'][id] = value;
        }

        updateContent() {
            //Меняем статус обновления контента
            this.isNeedUpdateContent = false;

            //Отфильтровать ткани
            let fabrics = this.filterItems(this.fabrics);

            //Формируем контентную область
            const content = this.sidebar.querySelector('.content');
            content.innerHTML = '';

            if (fabrics.length) {
                //Сгруппировать ткани
                fabrics = this.groupItems(fabrics);
                //Сортировать ткани
                fabrics = this.sortItems(fabrics);

                //Если ткани подходящие под фильтры найдены
                Object.keys(fabrics).forEach(categoryName => {
                    let fabricPrice = this.getCategoryPrice(fabrics[categoryName]['id']);
                    if (fabricPrice) {
                        fabricPrice = '+' + new Intl.NumberFormat("ru-RU").format(fabricPrice) + '₽ = '
                            + new Intl.NumberFormat("ru-RU").format(this.product['display_price'] + fabricPrice) + '₽';
                    } else {
                        fabricPrice = 'не влияют на стоимость';
                    }

                    const categoryWrapper = document.createElement('div');
                    categoryWrapper.classList.add('fabric-sidebar__category');
                    content.append(categoryWrapper);

                    const categoryTitle = document.createElement('span');
                    categoryTitle.classList.add('fabric-sidebar__category-title');
                    categoryTitle.innerHTML = '<b>Ткани ' + categoryName + ' категории:</b> ' + fabricPrice;
                    categoryWrapper.appendChild(categoryTitle);

                    Object.keys(fabrics[categoryName]['items']).forEach(textureName => {
                        const textureTitle = document.createElement('span');
                        textureTitle.classList.add('fabric-sidebar__texture-title');
                        textureTitle.innerHTML = textureName;
                        categoryWrapper.appendChild(textureTitle);

                        const contentWrapper = document.createElement('div');
                        contentWrapper.classList.add('fabric-sidebar__content-wrapper');
                        categoryWrapper.appendChild(contentWrapper);

                        fabrics[categoryName]['items'][textureName]['items'].forEach(fabric => {
                            const item = document.createElement('div');
                            item.classList.add('fabric-sidebar__item');
                            item.classList.add('item');
                            if (current_fabric['id'] === fabric['id']) item.classList.add('active');
                            item.dataset.id = fabric['id'];
                            contentWrapper.appendChild(item);

                            const checked = document.createElement('div');
                            checked.classList.add('fabric-sidebar__checked');
                            item.appendChild(checked);

                            const preview = document.createElement('img');
                            preview.classList.add('fabric-sidebar__preview');
                            preview.src = fabric['preview_url'];
                            item.appendChild(preview);

                            if (this.zarboFabrics.includes(fabric['sku'])) {
                                const ar = document.createElement('div');
                                ar.classList.add('fabric-sidebar__ar');
                                ar.innerHTML = 'AR';
                                item.appendChild(ar);
                            }

                            const info = document.createElement('div');
                            info.classList.add('fabric-sidebar__info');
                            info.classList.add('info');
                            item.appendChild(info);

                            const title = document.createElement('span');
                            title.classList.add('fabric-sidebar__title');
                            title.innerHTML = fabric['title'];
                            info.appendChild(title);

                            const moreInfoWrapper = document.createElement('div');
                            moreInfoWrapper.classList.add('fabric-sidebar__more-info-wrapper');
                            info.appendChild(moreInfoWrapper);

                            const moreInfo = document.createElement('span');
                            moreInfo.classList.add('fabric-sidebar__more-info');
                            moreInfo.innerHTML = 'Подробнее о ткани';
                            moreInfoWrapper.appendChild(moreInfo);
                        });
                    });
                });
            } else {
                //Если ткани подходящие под фильтры отсутствуют
                const fabricsNotFound = document.createElement('div');
                fabricsNotFound.classList.add('fabric-sidebar__not-found');
                fabricsNotFound.classList.add('fabric-sidebar-not-found');
                content.append(fabricsNotFound);

                const fabricsNotFoundTitle = document.createElement('span');
                fabricsNotFoundTitle.classList.add('fabric-sidebar-not-found__title');
                fabricsNotFoundTitle.innerHTML = 'Ткани не найдены';
                fabricsNotFound.appendChild(fabricsNotFoundTitle);

                if (this.getCountFilters()) {
                    const fabricsNotFoundResetFilters = document.createElement('a');
                    fabricsNotFoundResetFilters.classList.add('fabric-sidebar__reset-button');
                    fabricsNotFoundResetFilters.classList.add('reset-button');
                    fabricsNotFoundResetFilters.innerHTML = 'Сбросить фильтры';
                    fabricsNotFound.appendChild(fabricsNotFoundResetFilters);
                }

                const fabricsNotFoundWrapper = document.createElement('div');
                fabricsNotFoundWrapper.classList.add('fabric-sidebar-not-found__wrapper');
                fabricsNotFound.appendChild(fabricsNotFoundWrapper);

                const fabricsNotFoundSubtitle = document.createElement('span');
                fabricsNotFoundSubtitle.classList.add('fabric-sidebar-not-found__subtitle');
                fabricsNotFoundSubtitle.innerHTML = 'Получите онлайн-консультацию<br>продавца шоурума:';
                fabricsNotFoundWrapper.appendChild(fabricsNotFoundSubtitle);

                const fabricsNotFoundList = document.createElement('ul');
                fabricsNotFoundList.classList.add('fabric-sidebar-not-found__list');
                fabricsNotFoundWrapper.appendChild(fabricsNotFoundList);

                const fabricsNotFoundListFirstItem = document.createElement('li');
                fabricsNotFoundListFirstItem.classList.add('fabric-sidebar-not-found__list-item');
                fabricsNotFoundListFirstItem.innerHTML = 'Подберём обивку с учётом личных<br>предпочтений и&nbsp;дизайн-проекта.';
                fabricsNotFoundList.appendChild(fabricsNotFoundListFirstItem);

                const fabricsNotFoundListSecondItem = document.createElement('li');
                fabricsNotFoundListSecondItem.classList.add('fabric-sidebar-not-found__list-item');
                fabricsNotFoundListSecondItem.innerHTML = 'Отправим реальные фото и&nbsp;видео<br>тканей, без фильтров.';
                fabricsNotFoundList.appendChild(fabricsNotFoundListSecondItem);

                const productTitle = document.querySelector('.product-title').innerText;
                let ymClientId = document.cookie.match('(?:^|;)\\s*_ym_uid=([^;]*)');
                ymClientId = ymClientId ? decodeURIComponent(ymClientId[1]) : '';
                let ctSessionId = document.cookie.match('(?:^|;)\\s*_ct_session_id=([^;]*)');
                ctSessionId = ctSessionId ? decodeURIComponent(ctSessionId[1]) : '';
                const fabricsNotFoundButtonWa = document.createElement('a');
                fabricsNotFoundButtonWa.classList.add('fabric-sidebar-not-found__button');
                fabricsNotFoundButtonWa.classList.add('wa');
                fabricsNotFoundButtonWa.href = 'https://api.whatsapp.com/send/?phone=74957447222&text=Добрый день, у меня вопрос по товару: '
                    + productTitle + '. Просьба, чтобы мы не потеряли ваше обращение, не удаляйте эту строчку: ' + ymClientId + ' · ' + ctSessionId
                    + '&type=phone_number&app_absent=0';
                fabricsNotFoundButtonWa.innerHTML = '<span>Написать в</span><span>WhatsApp</span>';
                fabricsNotFoundWrapper.appendChild(fabricsNotFoundButtonWa);

                const fabricsNotFoundButtonTg = document.createElement('a');
                fabricsNotFoundButtonTg.classList.add("fabric-sidebar-not-found__button");
                fabricsNotFoundButtonTg.classList.add('tg');
                fabricsNotFoundButtonTg.href = 'https://t.me/Lavsit_ru';
                fabricsNotFoundButtonTg.innerHTML = '<span>Написать в</span><span>Telegram</span>';
                fabricsNotFoundWrapper.appendChild(fabricsNotFoundButtonTg);

                const fabricsNotFoundButtonMax = document.createElement('a');
                fabricsNotFoundButtonMax.classList.add('fabric-sidebar-not-found__button');
                fabricsNotFoundButtonMax.classList.add('max');
                fabricsNotFoundButtonMax.href = 'https://max.ru/u/f9LHodD0cOLJhQfQdiQ6UHh9b3EwvaJ9VepVG94Bo-tdNKhxDG08RasPFkc';
                fabricsNotFoundButtonMax.innerHTML = '<span>Написать в</span><span>Max</span>';
                fabricsNotFoundWrapper.appendChild(fabricsNotFoundButtonMax);

                const fabricsNotFoundDesc = document.createElement('span');
                fabricsNotFoundDesc.classList.add('fabric-sidebar-not-found__desc');
                fabricsNotFoundDesc.innerHTML = 'Поможем в чате, быстро и удобно';
                fabricsNotFoundWrapper.appendChild(fabricsNotFoundDesc);
            }

            //Формируем футер сайдбара
            const footer = this.sidebar.querySelector('.fabric-sidebar-footer');
            footer.innerHTML = '';

            const price = this.getCategoryPrice(current_fabric['category_id']);

            const preview = document.createElement('img');
            preview.classList.add('fabric-sidebar-footer__preview');
            preview.src = current_fabric['preview_url'];
            footer.appendChild(preview);

            const info = document.createElement('div');
            info.classList.add('fabric-sidebar-footer__info');
            footer.appendChild(info);

            const titleInfo = document.createElement('span');
            titleInfo.classList.add('fabric-sidebar-footer__title');
            titleInfo.innerHTML = !current_fabric['isCatalogFabric']
                ? this.textures.get(current_fabric['texture_id'])['name'] : 'По каталогу';
            titleInfo.innerHTML += ' ' + current_fabric['title'];
            info.appendChild(titleInfo);

            const priceInfo = document.createElement('span');
            priceInfo.classList.add('fabric-sidebar-footer__price');
            priceInfo.innerHTML = price ? '+' + new Intl.NumberFormat("ru-RU").format(price) + ' ₽' : 'бесплатно';
            info.appendChild(priceInfo);

            const button = document.createElement('div');
            button.classList.add('fabric-sidebar-footer__button');
            button.classList.add('button');
            button.classList.add('disabled');
            button.innerHTML = 'Выбрать ткань';
            footer.appendChild(button);
        }

        filterItems(items) {
            items = items.filter(item => {
                //Если это ткань по каталогу
                if (!this.filters['catalog']['isCatalogMode'] && item['type'] === 'catalog') return false;

                //Проверяем, подходит ли ткань под фильтры
                //Поиск
                if ('search' in this.filters && this.filters['search']['keywords']) {
                    //Артикул
                    if (item['slug'].toLowerCase().includes(this.filters['search']['keywords'].replace(/\./g, '-').toLowerCase())) return true;

                    //Название
                    if (item['title'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Описание
                    if (item['description'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Состав
                    if (item['composition'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Коллекция
                    if (item['collection'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Страна
                    if (item['country'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Цвет
                    const color = this.colors.get(item['color_id']);
                    if (color && color['name'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Фактура
                    const texture = this.colors.get(item['texture_id']);
                    if (texture && texture['name'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;

                    //Свойства
                    for (let propertyID of item['property_ids']) {
                        const property = this.properties.get(propertyID);
                        if (property && property['name'].toLowerCase().includes(this.filters['search']['keywords'].toLowerCase())) return true;
                    }

                    return false;
                }

                //Цена
                if (
                    this.filters['price']['min'] > (this.product['display_price'] + this.getCategoryPrice(item['category_id']))
                    || (this.product['display_price'] + this.getCategoryPrice(item['category_id'])) > this.filters['price']['max']
                ) {
                    return false;
                }

                //Категория
                if ('category' in this.filters && Object.values(this.filters['category']).some(boolean => boolean)) {
                    if (!item['category_id'] || !this.filters['category'][item['category_id']]) return false;
                }

                //Если ткань по каталогу
                if (this.filters['catalog']['isCatalogMode'] && item['type'] === 'catalog') return true;

                //Цвет
                if ('color' in this.filters && Object.values(this.filters['color']).some(boolean => boolean)) {
                    if (!item['color_id'] || !this.filters['color'][item['color_id']]) return false;
                }

                //Фактура
                if ('texture' in this.filters && Object.values(this.filters['texture']).some(boolean => boolean)) {
                    if (!item['texture_id'] || !this.filters['texture'][item['texture_id']]) return false;
                }

                //Избранное
                if ('favorite' in this.filters && this.filters['favorite']['isFavorite']) {
                    if (!current_fabrics_favorites.some(fabric => fabric['id'] === item['id'])) return false;
                }

                //AR
                if ('ar' in this.filters && this.filters['ar']['isAr']) {
                    if (!this.zarboFabrics.includes(item['sku'])) return false;
                }

                //Свойства
                if ('property' in this.filters && Object.values(this.filters['property']).some(boolean => boolean)) {
                    if (!item['property_ids'].length || !item['property_ids'].some(propertyID => this.filters['property'][propertyID])) return false;
                }

                return true;
            });

            return items;
        }

        groupItems(items) {
            const fabrics = {};

            //Основная группировка тканей
            items.forEach(item => {
                const category = this.categories.get(item['category_id']);
                if (category) {
                    const categoryName = /^\d+$/.test(category['name']) ? Number(category['name']) : category['name'];

                    if (!fabrics[categoryName]) {
                        fabrics[categoryName] = {
                            'id': item['category_id'],
                            'items': {}
                        };
                    }

                    const texture = this.textures.get(item['texture_id']);
                    if (texture) {
                        if (!fabrics[categoryName]['items'][texture['name']]) {
                            fabrics[categoryName]['items'][texture['name']] = {
                                'id': item['texture_id'],
                                'items': []
                            };
                        }

                        fabrics[categoryName]['items'][texture['name']]['items'].push(item);
                    }
                }
            });

            return fabrics;
        }

        sortItems(fabrics) {
            const {compare} = new Intl.Collator(undefined, {numeric: true});

            Object.keys(fabrics).forEach(categoryName => {
                Object.keys(fabrics[categoryName]['items']).forEach(textureName => {
                     fabrics[categoryName]['items'][textureName]['items'].sort((a, b) => compare(a['title'], b['title']));
                });
            });

            return fabrics;
        }

        getCategoryPrice(id) {
            let price = 0;

            //Расчёт цены от категории ткани
            const category = this.categories.get(id);
            if (category['price-multiple']) {
                price = (this.product['display_price'] * category['price-multiple']);
            }

            //Округление цену до сотни
            price = Math.ceil(price / 100) * 100;

            return price;
        }

        preSelectFabric(id) {
            //Получить объект выбираемой ткани
            id = Number(id);
            const fabric = this.fabrics.find(fabric => fabric['id'] === id);

            //Снять выделение с текущей ткани
            const currentFabricItem = this.sidebar.querySelector('.item.active');
            if (currentFabricItem) currentFabricItem.classList.remove('active');

            //Установить выделение на новую ткань
            this.sidebar.querySelector('.item[data-id="' + id + '"]').classList.add('active');

            //Сбросить статус обновления контента
            this.isNeedUpdateContent = current_fabric['id'] !== id;

            //Сгенерировать новый футер сайдбара
            const footer = this.sidebar.querySelector('.fabric-sidebar-footer');
            footer.innerHTML = '';

            const price = this.getCategoryPrice(fabric['category_id']);

            const preview = document.createElement('img');
            preview.classList.add('fabric-sidebar-footer__preview');
            preview.src = fabric['preview_url'];
            footer.appendChild(preview);

            const info = document.createElement('div');
            info.classList.add('fabric-sidebar-footer__info');
            footer.appendChild(info);

            const titleInfo = document.createElement('span');
            titleInfo.classList.add('fabric-sidebar-footer__title');
            titleInfo.innerHTML = !fabric['isCatalogFabric'] ? this.textures.get(fabric['texture_id'])['name'] : 'По каталогу';
            titleInfo.innerHTML += ' ' + fabric['title'];
            info.appendChild(titleInfo);

            const priceInfo = document.createElement('span');
            priceInfo.classList.add('fabric-sidebar-footer__price');
            priceInfo.innerHTML = price ? '+' + new Intl.NumberFormat("ru-RU").format(price) + '₽' : 'бесплатно';
            info.appendChild(priceInfo);

            const button = document.createElement('div');
            button.classList.add('fabric-sidebar-footer__button');
            button.classList.add('button');
            if (current_fabric['id'] === id) button.classList.add('disabled');
            button.innerHTML = 'Выбрать ткань';
            footer.appendChild(button);

            jQuery(document.body).trigger('fabric_main_sidebar_preselect', fabric);
        }

        setFabric(id) {
            //Получить объект ткани, что хотим применить
            const fabric = this.fabrics.find(fabric => fabric['id'] === Number(id));
            const color = this.colors.get(fabric['color_id']) ? this.colors.get(fabric['color_id']) : null;
            const category = this.categories.get(fabric['category_id']) ? this.categories.get(fabric['category_id']) : null;
            const texture = this.textures.get(fabric['texture_id']) ? this.textures.get(fabric['texture_id']) : null;
            let properties = [];
            fabric['property_ids'].forEach(propertyId => {
                if (this.properties.get(fabric[propertyId])) properties.push(this.properties.get(fabric[propertyId]));
            });

            //Устанавливаем ткань
            jQuery(productForm).trigger('fabric_changed', [fabric, color, category, texture, properties]);
        }

        openDetailsSidebar() {
            this.sidebarDetails.classList.add('open');

            //Обновить содержимое сайдбара при открытии
            if (this.isNeedUpdateDetailsContent) this.updateDetailsContent();
        }

        closeDetailsSidebar() {
            this.sidebarDetails.classList.remove('open');
        }

        updateDetailsContent() {
            //Меняем статус обновления контента
            this.isNeedUpdateDetailsContent = false;

            //Объект основной ткани
            const fabric = this.fabrics.find(fabric => fabric['id'] === Number(this.sidebarDetails.dataset.id));
            const category = this.categories.get(fabric['category_id']);
            const texture = this.textures.get(fabric['texture_id']);
            const properties = [];
            fabric['property_ids'].forEach(propertyId => properties.push(this.properties.get(propertyId)));

            //Формируем контентную область
            const content = this.sidebarDetails.querySelector('.content');
            content.innerHTML = '';

            const images = {};
            if (fabric['gallery_texture_urls']) images['texture'] = fabric['gallery_texture_urls'];
            if (fabric['gallery_sample_urls']) images['sample'] = fabric['gallery_sample_urls'];

            if (Object.keys(images).length) {
                const sliderWrapper = document.createElement('div');
                sliderWrapper.classList.add('fabric-details-sidebar__slider-wrapper');
                content.appendChild(sliderWrapper);

                const slider = document.createElement('div');
                slider.classList.add('fabric-details-sidebar__slider');
                slider.classList.add('fabric-details-slider');
                sliderWrapper.appendChild(slider);

                const sliderArrowPrev = document.createElement('div');
                sliderArrowPrev.classList.add('fabric-details-slider__arrow');
                sliderArrowPrev.classList.add('prev');
                slider.appendChild(sliderArrowPrev);

                const sliderInner = document.createElement('div');
                sliderInner.classList.add('fabric-details-slider__wrapper');
                sliderInner.classList.add('wrapper');
                slider.appendChild(sliderInner);

                Object.keys(images).forEach(type => {
                    images[type].forEach(url => {
                        const slide = document.createElement('div');
                        slide.classList.add('fabric-details-slider__slide');
                        slide.classList.add('slide');
                        slide.classList.add(type);
                        sliderInner.appendChild(slide);

                        const image = document.createElement('img');
                        image.classList.add('fabric-details-slider__image');
                        image.src = url;
                        slide.appendChild(image);
                    });
                });

                const sliderArrowNext = document.createElement('div');
                sliderArrowNext.classList.add('fabric-details-slider__arrow');
                sliderArrowNext.classList.add('next');
                slider.appendChild(sliderArrowNext);

                const closeButton = document.createElement('div');
                closeButton.classList.add('fabric-details-sidebar__close');
                closeButton.innerHTML = 'Назад';
                slider.appendChild(closeButton);
                closeButton.addEventListener('click', () => this.closeDetailsSidebar());

                const crossButton = document.createElement('div');
                crossButton.classList.add('fabric-details-sidebar__cross');
                slider.appendChild(crossButton);
                crossButton.addEventListener('click', () => this.closeDetailsSidebar());

                const pagination = document.createElement('div')
                pagination.classList.add('fabric-details-slider__pagination');
                slider.appendChild(pagination);

                const fullScreenButton = document.createElement('div');
                fullScreenButton.classList.add('fabric-details-slider__full-screen-button');
                slider.appendChild(fullScreenButton);
                fullScreenButton.addEventListener('click', () => slider.classList.toggle('full-screen'));

                var selectorTexture, selectorSample;
                if (images['texture'].length && images['sample'].length) {
                    const selector = document.createElement('div');
                    selector.classList.add('fabric-details-slider__selector');
                    sliderWrapper.appendChild(selector);

                    selectorTexture = document.createElement('div');
                    selectorTexture.classList.add('fabric-details-slider__selector-item');
                    selectorTexture.classList.add('active');
                    selectorTexture.innerHTML = 'фактура';
                    selector.appendChild(selectorTexture);
                    selectorTexture.addEventListener('click', () => {
                        if (selectorTexture.classList.contains('active')) return;

                        const slideIndex = Array.from(sliderWrapper.querySelectorAll('.slide'))
                            .indexOf(sliderWrapper.querySelector('.texture'));

                        slider.swiper.slideTo(slideIndex);
                    });

                    selectorSample = document.createElement('div');
                    selectorSample.classList.add('fabric-details-slider__selector-item');
                    selectorSample.innerHTML = 'на мебели';
                    selector.appendChild(selectorSample);
                    selectorSample.addEventListener('click', () => {
                        if (selectorSample.classList.contains('active')) return;

                        const slideIndex = Array.from(sliderWrapper.querySelectorAll('.slide'))
                            .indexOf(sliderWrapper.querySelector('.sample'));

                        slider.swiper.slideTo(slideIndex);
                    });
                }

                new Swiper(slider, {
                    'wrapperClass': 'wrapper',
                    'slideClass': 'slide',
                    'slidesPerView': 1,
                    'navigation': {
                        'prevEl': sliderArrowPrev,
                        'nextEl': sliderArrowNext
                    },
                    'pagination': {
                        'el': pagination,
                        'type': 'custom',
                        'renderCustom': (swiper, current, total) => {
                            let outputHTML = '';

                            if (total > 1) {
                                let activeBulletPosition = current;
                                if (total > 5) {
                                    if (current > 3) activeBulletPosition = 3;
                                    if (total - current < 3) activeBulletPosition = 5 - (total - current);
                                }

                                const bulletCount = total < 5 ? total : 5;
                                for (let i = 0; i < bulletCount; i++) {
                                    outputHTML += '<span class="bullet' + (i === activeBulletPosition - 1 ? ' active' : '') + '"></span>';
                                }
                            }

                            return outputHTML;
                        }
                    },
                    'on': {
                        'slideChange': swiper => {
                            if (selectorTexture && selectorSample) {
                                const slide = swiper.slides[swiper.activeIndex];

                                //Переключить селектор
                                if (slide.classList.contains('texture')) {
                                    selectorTexture.classList.add('active');
                                    selectorSample.classList.remove('active');
                                } else if (slide.classList.contains('sample')) {
                                    selectorTexture.classList.remove('active');
                                    selectorSample.classList.add('active');
                                }
                            }
                        }
                    }
                });
            }

            const top = document.createElement('div');
            top.classList.add('fabric-details-sidebar__top');
            content.appendChild(top);

            const titleWrapper = document.createElement('div');
            titleWrapper.classList.add('fabric-details-sidebar__title-wrapper');
            top.appendChild(titleWrapper);

            const titlePrefix = document.createElement('span');
            titlePrefix.classList.add('fabric-details-sidebar__title-prefix');
            titlePrefix.innerHTML = 'Ткань ';
            titleWrapper.appendChild(titlePrefix);

            const title = document.createElement('span');
            title.classList.add('fabric-details-sidebar__title');
            title.innerHTML = texture['name'] + ' ' + fabric['title'];
            titleWrapper.appendChild(title);

            const firstAddToFavoriteButton = document.createElement('div');
            firstAddToFavoriteButton.classList.add('fabric-details-sidebar__first-favorite-button');
            firstAddToFavoriteButton.classList.add('favorite-button');
            if (current_fabrics_favorites.some(_fabric => _fabric['id'] === fabric['id'])) {
                firstAddToFavoriteButton.classList.add('active');
                firstAddToFavoriteButton.innerHTML = 'В избранном';
            } else {
                firstAddToFavoriteButton.innerHTML = 'Добавить в избранное';
            }
            top.appendChild(firstAddToFavoriteButton);

            if (properties.length) {
                const propertySlider = document.createElement('div');
                propertySlider.classList.add('fabric-details-sidebar__property-slider');
                content.appendChild(propertySlider);

                const propertySliderWrapper = document.createElement('div');
                propertySliderWrapper.classList.add('fabric-details-sidebar__property-slider-wrapper');
                propertySliderWrapper.classList.add('wrapper');
                propertySlider.appendChild(propertySliderWrapper);

                properties.forEach(property => {
                    const propertySlide = document.createElement('div');
                    propertySlide.classList.add('fabric-details-sidebar__property-slider-slide');
                    propertySlide.classList.add('slide');
                    propertySlide.innerHTML = property['svg'] + property['name'];
                    propertySliderWrapper.appendChild(propertySlide);
                });

                new Swiper(propertySlider, {
                    'wrapperClass': 'wrapper',
                    'slideClass': 'slide',
                    'slidesPerView': 'auto',
                    'spaceBetween': 6
                });
            }

            const buttonsWrapper = document.createElement('div');
            buttonsWrapper.classList.add('fabric-details-sidebar__button-wrapper');
            content.appendChild(buttonsWrapper);

            const secondAddToFavoriteButton = document.createElement('div');
            secondAddToFavoriteButton.classList.add('fabric-details-sidebar__second-favorite-button');
            secondAddToFavoriteButton.classList.add('favorite-button');
            if (current_fabrics_favorites.some(_fabric => _fabric['id'] === fabric['id'])) {
                secondAddToFavoriteButton.classList.add('active');
                secondAddToFavoriteButton.innerHTML = 'В избранном';
            } else {
                secondAddToFavoriteButton.innerHTML = 'Добавить в избранное';
            }
            buttonsWrapper.appendChild(secondAddToFavoriteButton);

            const sampleButton = document.createElement('div');
            sampleButton.classList.add('fabric-details-sidebar__sample-button');
            sampleButton.classList.add('sample-button');
            sampleButton.innerHTML = 'Получить образец';
            buttonsWrapper.appendChild(sampleButton);

            const subtitle = document.createElement('span');
            subtitle.classList.add('fabric-details-sidebar__subtitle');
            subtitle.innerHTML = 'О ткани';
            content.appendChild(subtitle);

            const infoList = document.createElement('div');
            infoList.classList.add('fabric-details-sidebar__info-list');
            content.appendChild(infoList);

            if (texture) {
                const infoTexture = document.createElement('ul');
                infoTexture.classList.add('fabric-details-sidebar__info-element');
                infoTexture.innerHTML = 'Фактура: <b>' + texture['name'] + '</b>';
                infoList.appendChild(infoTexture);
            }

            if (fabric['martindale']) {
                const infoMartindale = document.createElement('li');
                infoMartindale.classList.add('fabric-details-sidebar__info-element');
                infoMartindale.innerHTML = 'Мартиндейл: <b>' + fabric['martindale'] + ' циклов</b>';
                infoList.appendChild(infoMartindale);
            }

            if (fabric['density']) {
                const infoDensity = document.createElement('li');
                infoDensity.classList.add('fabric-details-sidebar__info-element');
                infoDensity.innerHTML = 'Плотность: <b>' + fabric['density'] + ' г/м²</b>';
                infoList.appendChild(infoDensity);
            }

            if (fabric['composition']) {
                const infoComposition = document.createElement('li');
                infoComposition.classList.add('fabric-details-sidebar__info-element');
                infoComposition.innerHTML = 'Состав: <b>' + fabric['composition'] + '</b>';
                infoList.appendChild(infoComposition);
            }

            if (fabric['country']) {
                const infoCountry = document.createElement('li');
                infoCountry.classList.add('fabric-details-sidebar__info-element');
                infoCountry.innerHTML = 'Страна: <b>' + fabric['country'] + '</b>';
                infoList.appendChild(infoCountry);
            }

            if (fabric['ncs']) {
                const infoNcs = document.createElement('li');
                infoNcs.classList.add('fabric-details-sidebar__info-element');
                infoNcs.innerHTML = 'Цвет по NCS: <b>' + fabric['ncs'] + '</b>';
                infoList.appendChild(infoNcs);
            }

            if (fabric['ral']) {
                const infoRal = document.createElement('li');
                infoRal.classList.add('fabric-details-sidebar__info-element');
                infoRal.innerHTML = 'Цвет по RAL: <b>' + fabric['ral'] + '</b>';
                infoList.appendChild(infoRal);
            }

            if (category) {
                const infoCategory = document.createElement('li');
                infoCategory.classList.add('fabric-details-sidebar__info-element');
                infoCategory.innerHTML = 'Категория: <b>' + category['name'] + '</b>';
                infoList.appendChild(infoCategory);
            }

            if (fabric['description']) {
                const description = document.createElement('div');
                description.classList.add('fabric-details-sidebar__desc');
                description.innerHTML = fabric['description'];
                content.appendChild(description);
            }

            //Формируем футер сайдбара
            const footer = this.sidebarDetails.querySelector('.fabric-details-sidebar-footer');
            footer.innerHTML = '';

            const priceWrapper = document.createElement('div');
            priceWrapper.classList.add('fabric-details-sidebar-footer__price');
            priceWrapper.innerHTML = 'Цена в этой ткани<br><b>'
                + new Intl.NumberFormat("ru-RU").format(this.getCategoryPrice(fabric['category_id'])) + ' ₽</b>';
            footer.appendChild(priceWrapper);

            const footerSampleButton = document.createElement('div');
            footerSampleButton.classList.add('fabric-details-sidebar-footer__sample-button');
            footerSampleButton.classList.add('sample-button');
            footerSampleButton.innerHTML = 'Хочу получить образец';
            footer.appendChild(footerSampleButton);

            const button = document.createElement('div');
            button.classList.add('fabric-details-sidebar-footer__button');
            if (current_fabric['id'] === fabric['id']) button.classList.add('disabled');
            button.classList.add('button');
            button.innerHTML = 'Выбрать ткань';
            footer.appendChild(button);
        }

        openModalQr() {
            this.modalQr.classList.add('open');
        }

        closeModalQr() {
            this.modalQr.classList.remove('open');
        }

        async loadQRLib() {
            const url = '/wp-content/themes/savoy-child/assets/js/html5-qrcode.min.js';

            if (!this.qrPromise) {
                this.qrPromise = (async () => {
                    await new Promise((resolve, reject) => {
                        const s = document.createElement('script');
                        s.src = url;
                        s.onload = resolve;
                        s.onerror = () => { this.qrPromise = null; reject(); };
                        document.head.appendChild(s);
                    });
                })();
            }

            return this.qrPromise;
        }

        openQrSidebar() {
            this.sidebarQr.classList.add('open');

            //Обновить содержимое сайдбара при открытии
            if (this.isNeedUpdateQrContent) this.updateQrContent();
        }

        closeQrSidebar() {
            this.sidebarQr.classList.remove('open');
        }

        updateQrContent() {
            this.qrScanner = new Html5Qrcode('qr-sidebar-camera');

            Html5Qrcode.getCameras().then(devices => {
                if (devices) {
                    this.startScanQrCode(devices[0].id);

                    if (devices.length > 1) {
                        let deviceIndex = 0;

                        const changeCamButton = this.sidebarQr.querySelector('.change-camera');
                        changeCamButton.classList.add('active');
                        changeCamButton.addEventListener('click', () => {
                            if (
                                this.qrScanner.getState() === Html5QrcodeScannerState.SCANNING
                                || this.qrScanner.getState() === Html5QrcodeScannerState.PAUSED
                            ) {
                                this.qrScanner.stop();
                            }

                            setTimeout(() => {
                                deviceIndex = ++deviceIndex in devices ? deviceIndex: 0;
                                this.startScanQrCode(devices[deviceIndex].id);
                            }, 100);
                        });
                    }
                }
            });
        }

        startScanQrCode(deviceId) {
            const errorNode = this.sidebarQr.querySelector('.qr-error');
            const closeError = debounce(() => errorNode.classList.remove('active'), 5000);

            this.qrScanner.start(deviceId, {}, decodedText => {
                const url = new URL(decodedText);
                const currentURL = new URL(window.location.href);

                if (!url || url.host !== currentURL.host) {
                    errorNode.classList.add('active');
                    errorNode.innerHTML =
                        'Данный QR код не может быть использован для установки ткани. Обратитесь к менеджеру или выберете другую ткань вручную.';

                    closeError();
                    return;
                }

                const urlPathFragments = url.pathname.replace(/^\/|\/$/g, '').split('/');

                if (urlPathFragments[0] !== 'fabric') {
                    errorNode.classList.add('active');
                    errorNode.innerHTML =
                        'Ссылка в данном QR коде не содержит указания ткани. Обратитесь к менеджеру или выберете другую ткань вручную.';

                    closeError();
                    return;
                }

                const fabric = this.fabrics.find(fabric => fabric['slug'] === urlPathFragments[urlPathFragments.length - 1]
                    .replace(/\./g, '-'));
                if (!fabric) {
                    errorNode.classList.add('active');
                    errorNode.innerHTML =
                        'Не удалось найти ткань в каталоге. Обратитесь к менеджеру или выберете другую ткань вручную.';

                    closeError();
                    return;
                } else {
                    //Установить новую ткань
                    this.setFabric(fabric['id']);

                    this.closeQrSidebar();

                    document.querySelector('.qr-success').classList.add('active');
                    setTimeout(function () {
                        document.querySelector('.qr-success').classList.remove('active');
                    }, 3000);
                }
            });
        }
    }

    if (productForm.dataset.fabric_object) {
        if (productForm.classList.contains('variations_form')) {
            jQuery(productForm).one('show_variation', () => {
                new FabricMainSidebar(productForm);
            });
        } else {
            new FabricMainSidebar(productForm);
        }
    }
});